import { NewDate } from '@/Domain/News'
import { Currency } from '@/Domain/Batch/Currency'

export class FinalSettlementNegative {
    private _importeIngresarMadeira: Currency | null
    private _importeIngresarIva: Currency | null
    private _importeIngresarTotal: Currency | null
    private _dataingreso: NewDate | null

    constructor (
      importeIngresarMadeira: Currency | null,
      importeIngresarIva: Currency | null,
      importeIngresarTotal: Currency | null,
      dataingreso: NewDate | null
    ) {
      this._importeIngresarMadeira = importeIngresarMadeira
      this._importeIngresarIva = importeIngresarIva
      this._importeIngresarTotal = importeIngresarTotal
      this._dataingreso = dataingreso
    }

    get importeIngresarMadeira (): Currency {
      if (this._importeIngresarMadeira !== null) {
        return this._importeIngresarMadeira
      } else { return new Currency(0) }
    }

    get importeIngresarIva (): Currency {
      if (this._importeIngresarIva !== null) {
        return this._importeIngresarIva
      } else { return new Currency(0) }
    }

    get importeIngresarTotal (): Currency {
      if (this._importeIngresarTotal !== null) {
        return this._importeIngresarTotal
      } else { return new Currency(0) }
    }

    get dataingreso (): string {
      if (this._dataingreso !== null) {
        return this._dataingreso.date()
      } else { return '' }
    }
}
